import React from 'react'
import { useState, useEffect, useContext } from "react"
import * as toastr from "toastr"

import Loader from "Placements/Components/Loader"
import API from "Placements/API"
import getConfig from "Placements/Utils/GetRequestConfig.util"
import * as iconBack from 'Placements/Assets/img/icon/arrow-back-purple.png'
import UserContext from "Placements/User.context"
import Button from 'Placements/Components/Button'
import Styled from 'styled-components'


const DivStyled = Styled.div`
    margin: 0 2rem;
`
const LinkStyled = Styled.a`
    font-weight: 800;
    font-size: 1.3rem;
    display: flex;
    place-content: center;
`
const ButtonStyled = Styled(Button)`
    width: auto;    
    align-self: center;
    margin-bottom: -40px;
`

const Formulario = ({ props }: any) => {

    const [isLoading, setLoading] = useState(true)
    const [info, setInfos] = useState<Info>()
    const [sessao, setSessao]: any = useState(null)
    const { usuario }: any = useContext(UserContext)

    useEffect(() => {

        if(usuario == null){
            window.location.href = "#/login"
            return
        }

        API.Test.Last({ idUsuario: usuario.Id_Usuario }, getConfig())
            .then((response: any) => {
                setInfos(response.data)
            }).catch((error: any) => {
                toastr.error('Não foi possível recuperar informações', '');
                window.location.href = "#/login"
            }).finally(() => {
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        if (info && info.ultimoTesteUsuario > 0 && info.ultimoTesteIncompleto) {
            API.Sessao.Get({ idTesteUsuario: info.ultimoTesteUsuario }, getConfig())
                .then((response: any) => {
                    setSessao(response.data)
                }).catch((error: any) => {
                    toastr.error('Não foi possível recuperar informações', '');
                    window.location.href = "#/login"
                }).finally(() => {
                    setLoading(false)
                })
        }
    }, [info])

    const goToNewTest = async (e: any) => {
        localStorage.setItem("SessaoPl", null)
        window.location.href = "#/choose-school"

    }
    const goToTest = async (e: any) => {
        localStorage.setItem("SessaoPl", JSON.stringify(sessao))
        window.location.href = "#/test"
    }

    const onLogout = () => {
        props.onLogout()
        window.location.href = "#/login"
    }

    return (
        <div className="form-welcome">
            {isLoading && <Loader />}
            <div className="top">
                <div onClick={onLogout} >
                    <img src={iconBack} />
                </div>
            </div>
            <div>
                <h3 className="form-title">{`Olá ${usuario.Nome}, tudo bem?`}</h3>
                <p className="form-txt">Você quer continuar um teste que você já começou, ou começar um do zero?</p>
                <DivStyled>
                    {info && info.ultimoTesteUsuario > 0 && info.ultimoTesteIncompleto &&
                        < Button
                            className="form-btn btn"
                            onClick={goToTest}
                        >
                            Eu quero continuar!
                        </Button>
                    }
                    <Button
                        className="form-btn btn"
                        onClick={goToNewTest}
                    >
                        Eu quero começar de novo!
                        </Button>
                    {info && !info.ultimoTesteIncompleto && info.ultimoTesteConsolidado > 0 &&
                        < LinkStyled href="#/test/final-report" className="link">
                            Só quero ver o meu último relatório
                        </LinkStyled>
                    }
                </DivStyled>
        </div>
        </div >
    )
}

export default Formulario